<template>
  <div class="text-center">
    <h2 class="mb-5 uppercase max-w-142 mx-auto">
      {{ component.title }}
    </h2>
  </div>
  <div
    class="flex flex-col md:flex-row relative justify-center flex-nowrap items-center gap-[3em]"
  >
    <div class="flex flex-col justify-center items-center">
      <strapi-image
        v-if="component.imageLeft"
        :image="component.imageLeft"
        :alt="component.imageLeft.alternativeText"
        :width="300"
        :height="200"
        class="object-contain mb-4"
      />
      <p class="mb-2 text-brand font-bold max-w-fit">
        {{ component.tagLineLeft }}
      </p>
      <p
        class="text-brand text-center font-bold mb-0 max-w-fit text-5xl leading-none"
      >
        {{ component.headlineLeft }}
      </p>
    </div>
    <p class="text-brand font-bold m-0 text-6xl">=</p>
    <div class="flex flex-col justify-center items-center">
      <strapi-image
        v-if="component.imageRight"
        :image="component.imageRight"
        :alt="component.imageRight.alternativeText"
        :width="300"
        :height="200"
        class="object-contain mb-4"
      />
      <p class="mb-2 text-brand font-bold max-w-fit">
        {{ component.tagLineRight }}
      </p>
      <p
        class="text-brand text-center font-bold mb-0 max-w-fit text-5xl leading-none"
      >
        {{ component.headlineRight }}
      </p>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { StrapiVerticalMediaCompare } from '~/apollo/types/types';

defineProps<{
  component: StrapiVerticalMediaCompare;
}>();
</script>
